module.exports = __webpack_public_path__ + "img/합정 카페.e79184ed.png";